import { Component, inject } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    // template: `<div class="layout-footer">
    //     Designed by <a href="#" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Data Steep</a> © 2026 All rights reserved.
    // </div>`
    template: `<div class="layout-footer">
        Designed by Data Steep © 2026 All rights reserved.
    </div>`
})
export class AppFooter {}
